module.exports = __webpack_public_path__ + "img/demo1@2x.c38f9032.png";